export function SuiteLogo({ productName, compact = false }) {
  return (
    <div
      className="suite-brand"
      aria-label={`Tribunalea ${productName}`}
    >
      <span className="suite-brand-mark" aria-hidden="true">
        <svg viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="4" className="suite-logo-core" />
          <circle cx="16" cy="4" r="2" className="suite-logo-node" />
          <circle cx="26.4" cy="10" r="2" className="suite-logo-node" />
          <circle cx="26.4" cy="22" r="2" className="suite-logo-node" />
          <circle cx="16" cy="28" r="2" className="suite-logo-node" />
          <circle cx="5.6" cy="22" r="2" className="suite-logo-node" />
          <circle cx="5.6" cy="10" r="2" className="suite-logo-node" />
          <g className="suite-logo-lines" strokeWidth="1">
            <line x1="16" y1="16" x2="16" y2="4" />
            <line x1="16" y1="16" x2="26.4" y2="10" />
            <line x1="16" y1="16" x2="26.4" y2="22" />
            <line x1="16" y1="16" x2="16" y2="28" />
            <line x1="16" y1="16" x2="5.6" y2="22" />
            <line x1="16" y1="16" x2="5.6" y2="10" />
          </g>
        </svg>
      </span>
      {!compact && (
        <span className="suite-brand-copy">
          <strong>Tribunalea</strong>
          <span>{productName}</span>
        </span>
      )}
    </div>
  );
}
